var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.7083 5.46634L3.5 16.6747C2.33333 15.933 1.875 14.608 1.875 13.333V6.66634C1.875 3.81634 2.98333 2.70801 5.83333 2.70801H10.8333C13.2417 2.70801 14.4083 3.49967 14.7083 5.46634Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.7909 7.70801V13.333C14.7909 13.3997 14.7826 13.4497 14.7826 13.508C14.7826 13.5663 14.7742 13.6247 14.7742 13.683H14.7826C14.6909 16.2747 13.5659 17.2913 10.8326 17.2913H5.83257C5.62424 17.2913 5.43257 17.283 5.24091 17.258L14.7909 7.70801Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.7754 13.6838C14.7754 13.6255 14.7837 13.5671 14.7837 13.5088C14.7921 13.5671 14.7921 13.6255 14.7837 13.6838H14.7754Z",
    fill: "#35446F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.7837 6.30859C14.7921 6.36693 14.7921 6.43359 14.7837 6.49193C14.7837 6.43359 14.7754 6.37526 14.7754 6.31693L14.7837 6.30859Z",
    fill: "#35446F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9587 6.98047V13.0138C18.9587 14.2055 18.3837 14.6805 18.0421 14.8555C17.8837 14.9388 17.6421 15.0305 17.3337 15.0305C16.9754 15.0305 16.5254 14.9138 16.0087 14.5471L14.7837 13.6805H14.7754C14.7754 13.6221 14.7837 13.5638 14.7837 13.5055C14.7837 13.4471 14.7921 13.3971 14.7921 13.3305V7.70547L17.5171 4.98047C17.7421 4.99714 17.9171 5.0638 18.0421 5.1388C18.3837 5.3138 18.9587 5.7888 18.9587 6.98047Z",
    fill: "#35446F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1408 1.86035C17.8908 1.61035 17.4824 1.61035 17.2324 1.86035L1.85742 17.2437C1.60742 17.4937 1.60742 17.902 1.85742 18.152C1.98242 18.2687 2.14076 18.3354 2.30742 18.3354C2.47409 18.3354 2.63242 18.2687 2.75742 18.1437L18.1408 2.76035C18.3991 2.51035 18.3991 2.11035 18.1408 1.86035Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon02);
export default __webpack_public_path__ + "static/media/video-icon-02.a6fe717ca99a2ac4440ec98b9e08736b.svg";
export { ForwardRef as ReactComponent };